import { SongwriterSummary } from '@Entities/songwriter/songwriter-summary'
import { ResultPage } from '@Entities/result-page'
import SongwriterSummaryCard from '@Components/Cards/SongwriterSummaryCard'
import React from 'react'
import { observer } from 'mobx-react'

interface SongwriterSummaryViewProps {
    songwriters: ResultPage<SongwriterSummary>
}

const SongwriterSummaryView = ({ songwriters }: SongwriterSummaryViewProps) => (
    <section className="songwriter-summary-view">
        {songwriters?.content.map((item: SongwriterSummary) => (
            <SongwriterSummaryCard key={item.id} {...item} />
        ))}
    </section>
)

export default observer(SongwriterSummaryView)
